import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
class ManageStructureHull extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addStructureHull:
            {
                structureAndHullId: 0,
                name: "",
                material: "",
                location: "",
                remarks: "",
                parts: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            },
            StructureAndHull: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/ShipAdd");
    }

    static getDerivedStateFromProps(props, state) {
        if (props.StructureHullList) {
            state.StructureAndHull = props.StructureHullList;
        }
        if (props.StructureHullDetails) {
            state.addStructureHull = props.StructureHullDetails;
        }
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addStructureHull[nodeName] = e.target.value;
        this.setState({});
    }

    addStructureHullDetails() {
        this.state.StructureAndHull.push(this.state.addStructureHull);
        this.props.dispatch({ type: "GetStructureHullList", data: this.state.StructureAndHull });
        this.setState({addStructureHull:
            {
                structureAndHullId: 0,
                name: "",
                material: "",
                location: "",
                remarks: "",
                parts: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            }});
        // this.hideSidePanel();
    }

    cancel() {
        this.hideSidePanel();
    }

    UpdateStructureHull() {
        const { addStructureHull } = this.state;
        var index = this.state.StructureAndHull.findIndex(x => x.structureAndHullId === addStructureHull.structureAndHullId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                StructureAndHull: [
                    ...this.state.StructureAndHull.slice(0, index),
                    Object.assign({}, this.state.StructureAndHull[index], addStructureHull),
                    ...this.state.StructureAndHull.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetStructureHullList", data: this.state.StructureAndHull });
                this.hideSidePanel();
            });
        }
    }


    render() {
        const { EditMaterial } = this.props;

        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                        </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {EditMaterial ? "Edit " : "Add "} Structure & Hull
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" className="form-control" name="name" value={this.state.addStructureHull.name} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" className="form-control" name="location" value={this.state.addStructureHull.location} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" className="form-control" name="material" value={this.state.addStructureHull.material} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Parts </label><br></br>
                                                <input type="text" className="form-control" name="parts" value={this.state.addStructureHull.parts} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" name="remarks" value={this.state.addStructureHull.remarks} onChange={e => this.handleInputChange(e)} ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Approximate Quantity
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" name="quantity" value={this.state.addStructureHull.quantity} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" name="unit" value={this.state.addStructureHull.unit} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" name="pchmchm" value={this.state.addStructureHull.pchmchm} onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {!EditMaterial ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addStructureHullDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                :
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdateStructureHull()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                            }
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        StructureHullList: state.MasterScreenReducer.StructureHullList || [],
        EditMaterial: state.MasterScreenReducer.EditMaterial,
        StructureHullDetails: state.MasterScreenReducer.StructureHullDetails,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageStructureHull));